import { render, staticRenderFns } from "./time.vue?vue&type=template&id=af24e72a&"
import script from "./time.vue?vue&type=script&lang=js&"
export * from "./time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports